import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export default function Footer() {
  const { t } = useTranslation('landing');

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.logo}>
          <svg width="28" height="28" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="8" fill="#132d52" />
            <rect x="17" y="8" width="3" height="24" rx="1.5" fill="white" />
            <rect x="22" y="13" width="3" height="14" rx="1.5" fill="#5BA4CF" />
            <rect x="12" y="15" width="3" height="10" rx="1.5" fill="white" opacity=".7" />
          </svg>
          <span className={styles.brand}>
            Vox<span>Reports</span>
          </span>
        </div>
        <div className={styles.links}>
          <a href="https://app.voxreports.com" target="_blank" rel="noreferrer">
            {t('footer.platform')}
          </a>
          <span className={styles.sep}>·</span>
          <a href="/terminos">{t('footer.terms')}</a>
        </div>
        <div className={styles.copy}>
          {t('footer.copy')}{' '}
          <a href="https://nativapps.com/" target="_blank" rel="noreferrer" className={styles.brandLink}>
            NativApps
          </a>
        </div>
      </div>
    </footer>
  );
}
